import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueTelInput from "vue-tel-input";
import "sweetalert2/dist/sweetalert2.min.css";

createApp(App).use(store).use(router).mount("#app");
